<script setup>
defineProps({
  label: { type: String, required: true },
});

defineEmits(['select']);
</script>

<template>
  <!-- tabindex -1: focus is managed by the parent menu's arrow keys, so Tab
       moves out of the menu rather than through it. -->
  <button type="button" role="menuitem" tabindex="-1" class="hub-menu-item" @click="$emit('select')">
    <slot name="icon" />
    {{ label }}
  </button>
</template>

<style scoped>
.hub-menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 11px;
  border: 0;
  border-radius: 9px;
  background: transparent;
  color: var(--xl-color-secondary-text);
  font: inherit;
  font-size: 13.5px;
  text-align: left;
  cursor: pointer;
  transition: background 0.12s, color 0.12s;
}

.hub-menu-item :deep(svg) {
  flex: 0 0 auto;
  color: var(--xl-color-outline-variant);
}

.hub-menu-item:hover {
  background: var(--xl-color-border-subtle);
  color: var(--xl-color-primary-text);
}

.hub-menu-item:hover :deep(svg) {
  color: var(--xl-color-primary);
}

.hub-menu-item:focus-visible {
  outline: 2px solid #5e2f78;
  outline-offset: -2px;
}
</style>
